import * as React from 'react'

import { Box } from '@material-ui/core'
import { DisplayGroupDetail } from '../components/DisplayGroupDetail'
import { useParams } from 'react-router'

type DisplayGroupPageProps = IDisplayGroupPageProps

interface IDisplayGroupPageProps {}

export const DisplayGroupPage: React.FC<DisplayGroupPageProps> = props => {
  const { id } = useParams<{ id: string }>()

  if (!id) throw Error('Display Group ID is required')

  return (
    <Box>
      <DisplayGroupDetail displayGroupId={id} />
    </Box>
  )
}
